import { useEffect } from 'react';

export const useScriptLoader = (scriptUrl, scriptId, className, type) => {
    useEffect(() => {
        // If scriptUrl is not provided, do nothing
        if (!scriptUrl) {
            return;
        }
        // Check if the script has already been added to avoid duplicates
        if (document.getElementById(scriptId)) {
            return;
        }

        // Create the script element
        const script = document.createElement('script');
        if (className && type) {
            script.className = className;
            script.type = type;
        }
        script.id = scriptId;
        script.src = scriptUrl;
        script.async = true;
        document.body.appendChild(script);

        // Cleanup function to remove the script when the component unmounts
        return () => {
            const scriptElement = document.getElementById(scriptId);
            if (scriptElement) {
                document.body.removeChild(scriptElement);
            }
        };
    }, [scriptUrl, scriptId, className, type]);
};
